import { render, staticRenderFns } from "./PlanItemForm.vue?vue&type=template&id=45767be9&"
import script from "./PlanItemForm.vue?vue&type=script&lang=js&"
export * from "./PlanItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports